import Meta from '@/components/common/Meta'

import UBoxContainerStoragePage from '@/v2/components/pages/landing-pages/u-box-container-storage-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/u-box-container-storage-page'

interface UBoxContainerStoragePageProps {}

const Page: React.FC<UBoxContainerStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.u_box_container_storage.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.u_box_container_storage?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.u_box_container_storage?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <UBoxContainerStoragePage />
    </>
  )
}

export default Page
